import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const RatingClient = () => {
  return (
    <SettingsMetaData propertyName={"Rating_Client"} viewPropertyName={"Performance Rating"} />
  );
};
export default RatingClient;